"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingUpdateInterface = exports.IBookingLookupPdfRequest = exports.BookingsCreateResponseInterface = exports.BookingsCreateInterface = exports.compare = exports.BookingGetInterface = exports.BookingWithContextData = exports.BookingData = void 0;
const t = __importStar(require("io-ts"));
const NonEmptyString_1 = require("../NonEmptyString");
const EMailString_1 = require("../EMailString");
const ISO8601_1 = require("../ISO8601");
exports.BookingData = t.type({
    name: NonEmptyString_1.NonEmptyString,
    email: t.union([EMailString_1.EMailString, t.undefined, t.null]),
});
exports.BookingWithContextData = t.type(Object.assign(Object.assign({ id: t.number }, exports.BookingData.props), { startDate: ISO8601_1.ISO8601, endDate: ISO8601_1.ISO8601, timeslotId: t.number }));
exports.BookingGetInterface = exports.BookingWithContextData;
function compare(left, right) {
    return left.startDate < right.startDate
        ? -1
        : left.startDate === right.startDate
            ? 0
            : 1;
}
exports.compare = compare;
exports.BookingsCreateInterface = t.type({
    participantNames: t.readonlyArray(NonEmptyString_1.NonEmptyString),
    email: t.union([EMailString_1.EMailString, t.undefined, t.null]),
    bookingDay: ISO8601_1.ISO8601,
    lookupUrl: t.string,
});
exports.BookingsCreateResponseInterface = t.type({
    status: t.union([t.literal('ok'), t.literal('mail_undeliverable')]),
    bookings: t.readonlyArray(exports.BookingGetInterface),
    lookupToken: t.union([t.string, t.undefined, t.null]),
    isMailDomainUnreliable: t.union([t.boolean, t.undefined, t.null]),
});
exports.IBookingLookupPdfRequest = t.type({
    lookupUrl: t.string,
    lookupToken: t.string,
});
exports.BookingUpdateInterface = t.type({
    name: NonEmptyString_1.NonEmptyString,
    email: t.union([EMailString_1.EMailString, t.undefined, t.null]),
    bookingDay: ISO8601_1.ISO8601,
    lookupUrl: t.string,
});
//# sourceMappingURL=Booking.js.map